module.exports = __webpack_public_path__ + "img/Breaking_Bad_back_and_forth.516e31c2.jpg";